// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-photos .upload-file{width:550px;height:535px}.upload-photos .upload-file__container{height:428px}.upload-photos .upload-file__actions{display:none}`, "",{"version":3,"sources":["webpack://./src/modals/CreateActivity/UploadPhotos/style.scss"],"names":[],"mappings":"AAEE,4BACE,WAAA,CACA,YAAA,CAEA,uCACE,YAAA,CAGF,qCACE,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
